import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class BannerService {

    private closed: boolean = false;
    private visible: boolean = false;

    constructor() { }

    showBanner(): void {
        this.visible = true;
    } // showBanner()

    hideBanner(): void {
        this.visible = false;
    } // hideBanner()

    closeBanner(): void {
        this.closed = true;
    } // closeBanner()

    isBannerVisible(): boolean {
        return this.visible && !this.closed;
    } // isBannerVisible()
}
